export const topicsCacheExchange = {
  updates: {
    Mutation: {
      removeTopic(result, _args, cache) {
        const topicId = _args.topicRemoveInput.id;
        cache.invalidate({ __typename: 'Topic', id: topicId });
      },
    },
  },
};
